// extracted by mini-css-extract-plugin
export default {"cameraRoot":"cameraRoot--fpiLn","cameraCloseButton":"cameraCloseButton--IWKhR"};